/* eslint-disable jsx-a11y/no-distracting-elements */
import { Button, Container, Grid, Link, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { HashLink } from "react-router-hash-link";
import { Typewriter } from "react-simple-typewriter";

const Banner = () => {
  return (
    <Box style={{ backgroundColor: "#111a28", paddingTop: "5%" }}>
      <Container>
        <Grid container spacing={2} paddingTop={10}>
          <Grid item xs={12} md={6}>
            <Box style={{ textAlign: "left" }}>
              <h2 style={{ marginBottom: "0px", color: "#00cf5d" }}>
                Hello! I am
              </h2>
              <Typography
                variant="h1"
                sx={{ fontSize: { xs: 43, sm: 50, md: 57 } }}
              >
                Prantosh Bepari
              </Typography>
              <h2 style={{ margin: "0px", color: "#00cf5d" }}>
                Junior Full Stack Developer
              </h2>
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  fontSize: { xs: "16px", sm: "18px", md: "20px" },
                }}
              >
                <Typewriter
                  words={["Web Designer", "Web Developer", "Programmer"]}
                  loop={true}
                  cursor
                  cursorStyle="..."
                  typeSpeed={80}
                  deleteSpeed={60}
                  delaySpeed={1000}
                />
              </Typography>
              <br />
              <Button sx={{ mr: 2, mt: 1 }} variant="contained" size="large">
                <Link
                  style={{ textDecoration: "none", color: "#fff" }}
                  target="_blank"
                  href="https://drive.google.com/file/d/1xMiWnwivJjSzciF-9n_z9CcFAQU_13sm/view?usp=sharing"
                >
                  Get Resume
                </Link>
              </Button>
              <HashLink
                style={{ textDecoration: "none" }}
                smooth
                to="/home#about"
              >
                <Button
                  sx={{ color: "white", mt: 1 }}
                  variant="outlined"
                  size="large"
                >
                  About Me
                </Button>
              </HashLink>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}></Grid>
          {/* <div>
              <marquee>
                <b>।। বিজ্ঞপ্তি ।।</b>
              </marquee>

              <br />
              <marquee
                behavior="scroll"
                direction="down"
                scrollamount="5"
                height="100px"
              >
                Down
              </marquee>

              <marquee
                behavior="scroll"
                direction="up"
                scrollamount="5"
                height="100px"
              >
                Up
              </marquee>

              <marquee
                behavior="scroll"
                direction="left"
                scrollamount="5"
                width="100%"
              >
                Left
              </marquee>

              <marquee
                behavior="scroll"
                direction="right"
                scrollamount="5"
                width="100%"
              >
                Right
              </marquee>

              <marquee width="100%" behavior="alternate">
                Alternate
              </marquee>
            </div> */}
        </Grid>
      </Container>
    </Box>
  );
};

export default Banner;
